import { ComunidadAdminContent } from "./comunidad/ComunidadAdminContent";

export const ComunidadAdminTab = () => {
  return <ComunidadAdminContent />;
};
